import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Mail, Linkedin, Twitter } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#003366] text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <Shield className="h-8 w-8 text-[#0078D4]" />
              <span className="text-2xl font-bold">Solving365</span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Expert Microsoft 365 and Azure AD consultancy. Get professional technical support on-demand with guaranteed response times.
            </p>
            <div className="flex space-x-4">
              <a href="mailto:phatak.kau@live.com" className="hover:text-[#0078D4] transition-colors">
                <Mail className="h-5 w-5" />
              </a>
              <a href="#" className="hover:text-[#0078D4] transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="#" className="hover:text-[#0078D4] transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/#features" className="text-gray-300 hover:text-white transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/#pricing" className="text-gray-300 hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="text-gray-300 hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-gray-300 hover:text-white transition-colors">
                  Get Started
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Email: phatak.kau@live.com</li>
              <li>Response: 24hr SLA</li>
              <li>Priority: 1hr SLA</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Solving365. All rights reserved. Expert Microsoft 365 Consultancy.</p>
        </div>
      </div>
    </footer>
  );
}
